module.exports = __webpack_public_path__ + "img/code.e1493403.svg";